/**
 * Generated runtime TestId mirror for frontend/src/components/shared/ScriptEditorCore.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

export const ScriptEditorCoreTestIds = {
  assistError: "assist-error",
  assistPanel: "assist-panel",
  assistPanelBody: "assist-panel-body",
  assistSuggestion: "assist-suggestion",
  badgeSyntaxOk: "badge-syntax-ok",
  btnApplySuggestion: "btn-apply-suggestion",
  btnCancelReplace: "btn-cancel-replace",
  btnCheckSyntax: "btn-check-syntax",
  btnCloseAssist: "btn-close-assist",
  btnConfirmReplace: "btn-confirm-replace",
  btnFixWithAi: "btn-fix-with-ai",
  btnInsertAtCursor: "btn-insert-at-cursor",
  btnInsertSql: "btn-insert-sql",
  btnShowAllErrors: "btn-show-all-errors",
  btnSuggest: "btn-suggest",
  btnToggleAssist: "btn-toggle-assist",
  editorContainer: "editor-container",
  editorCoreSqlToolbar: "editor-core-sql-toolbar",
  editorCoreToolbar: "editor-core-toolbar",
  errorSummaryBar: "error-summary-bar",
  inputAssistRequest: "input-assist-request",
  rateLimitWarning: "rate-limit-warning",
  scriptEditorCore: "script-editor-core"
} as const;
